import { Component, HostListener, ViewEncapsulation, inject } from "@angular/core";
import { ManualPageType } from "@app/manual/models/manual-page-type";
import { Pages } from "@constants/pages/Pages";
import { TabService } from "@services/tabs/TabService";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";

@Component({
    selector: "api-powerbi-usage",
    templateUrl: "./api-powerbi-usage.component.html",
    styleUrls: ["./api-powerbi-usage.component.scss"],
    // The translated paragraphs render through [innerHTML], which emulated encapsulation does not
    // style. The stylesheet scopes itself to this element instead.
    encapsulation: ViewEncapsulation.None,
    imports: [TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class ApiPowerBIUsageComponent {
    private _tabService = inject(TabService);
    private _pages = inject(Pages);

    apiUrl: string;

    constructor() {
        this.apiUrl = window.location.origin + "/api";
    }

    /** Links inside translated [innerHTML] paragraphs cannot bind (click), so they are handled here by class. */
    @HostListener("click", ["$event"])
    onLinkClick(event: MouseEvent) {
        const link = (event.target as HTMLElement).closest("a");
        if (link?.classList.contains("open-profile")) {
            this.openProfile();
        } else if (link?.classList.contains("open-release-notes")) {
            this.openReleaseNotes();
        } else if (link?.classList.contains("open-api-usage-manual")) {
            this.openApiUsageManual();
        } else if (link?.classList.contains("open-example-api-manual")) {
            this.openGetRiskDataManual();
        }
    }

    openProfile() {
        this._tabService.generateTab(this._pages.Profile, null, null, null, "api-keys");
    }

    openReleaseNotes() {
        window.open(this._pages.ReleaseNotesExternal, "_blank");
    }

    openApiUsageManual() {
        this._tabService.openInternalManual(ManualPageType.ApiUsage);
    }

    openGetRiskDataManual() {
        this._tabService.openInternalManual(ManualPageType.RiskDataApi);
    }
}
